/*
 * @Author: jiaming.zhao
 * @Date: 2021-11-23 20:01:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-16 10:51:58
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langConf from '../assets/lang/index'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en', // 语言标识
  fallbackLocale: 'en',
  messages: langConf.config
})

export default i18n

// 重新封装方法 
export function $t(args) { 
  return i18n.tc.call(i18n, args); 
} 
